import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardProgressComponent } from './wizard-progress/wizard-progress.component';

@NgModule({
  declarations: [WizardProgressComponent],
  imports: [CommonModule],
  exports: [WizardProgressComponent],
  providers: [],
})
export class CanvasWizardModule {}
